analytics.eventConfig.push({
  target: ".footer-full-width", //secondary nav
  events: [
    {
      eventTarget: ".subscription-wrapper .cta-button a.button-primary",
      eventType: "click",
      tags: {
        event: "outbound",
        componentType: "Footer",
        interactionType: "click", // possible values: click, videoPlay
        elementClicked: "button", // possible values: link, button, video
        contentTitle: "",
        destinationURL: "",
      },
    },
    {
      eventTarget: ".subscription-wrapper .cta-button a.button-secondary",
      eventType: "click",
      tags: {
        event: "outbound",
        componentType: "Footer",
        interactionType: "click", // possible values: click, videoPlay
        elementClicked: "button", // possible values: link, button, video
        contentTitle: "",
        destinationURL: "",
      },
    },
    {
      eventTarget: ".subscription-wrapper .cta-button a.button-secondary-white",
      eventType: "click",
      tags: {
        event: "outbound",
        componentType: "Footer",
        interactionType: "click", // possible values: click, videoPlay
        elementClicked: "button", // possible values: link, button, video
        contentTitle: "",
        destinationURL: "",
      },
    },
    {
      eventTarget:".subscription-wrapper .cta-button-popup-modal a.button-primary",
      eventType: "click",
      tags: {
        event: "outbound",
        componentType: "Footer",
        interactionType: "click", // possible values: click, videoPlay
        elementClicked: "button", // possible values: link, button, video
        contentTitle: "",
        destinationURL: "",
      },
    },
    {
      eventTarget:".subscription-wrapper .cta-button-popup-modal a.button-secondary",
      eventType: "click",
      tags: {
        event: "outbound",
        componentType: "Footer",
        interactionType: "click", // possible values: click, videoPlay
        elementClicked: "button", // possible values: link, button, video
        contentTitle: "",
        destinationURL: "",
      },
    },
    {
      eventTarget: ".subscription-wrapper .cta-button-popup-modal a.button-secondary-white",
      eventType: "click",
      tags: {
        event: "outbound",
        componentType: "Footer",
        interactionType: "click", // possible values: click, videoPlay
        elementClicked: "button", // possible values: link, button, video
        contentTitle: "",
        destinationURL: "",
      },
    },
    {
      eventTarget: ".subscription-wrapper .cta-button-popup-modal a.button-tertiary",
      eventType: "click",
      tags: {
        event: "outbound",
        componentType: "Footer",
        interactionType: "click", // possible values: click, videoPlay
        elementClicked: "link", // possible values: link, button, video
        contentTitle: "",
        destinationURL: "",
      },
    },
    {
      eventTarget: ".subscription-wrapper .cta-button a.button-tertiary",
      eventType: "click",
      tags: {
        event: "outbound",
        componentType: "Footer",
        interactionType: "click", // possible values: click, videoPlay
        elementClicked: "link", // possible values: link, button, video
        contentTitle: "",
        destinationURL: "",
      },
    },
  ],
});
